import {gaSiteName} from "../Constants/config";
import { parseQueryString } from "./generic";
import { _getItemFromLocal } from "./Helpers/LocalKeys";

export const raiseGAEvent = ({
  new_Category,
  new_Action,
  new_Label,
  failureReason=undefined,
  filter=undefined
}) => {
  const params = parseQueryString();
  const getJourneySource = () => {
    if (params && params.source_id) {
      return params.source_id;
    }
    return "Direct";
  };
  function gtag(eventData) {
    // console.log(`analytics - ${JSON.stringify(eventData)}`);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(eventData);
  }
  gtag({
    event: gaSiteName,
    new_Category,
    new_Action,
    new_Label,
    failure_Reason: failureReason,
    journey_Source: "",
    Filter: filter,
    Source: _getItemFromLocal("_sr") || "Web"
    // page_location: '/workflow',
    // page_referrer: 'https://healthhub.jio.com'
  });
};